import template from './app.html';
import controller from './app.controller';

let appComponent = {
  template,
  restrict: 'E',
  controller
};

export default appComponent;



// WEBPACK FOOTER //
// ./client/app/app.component.js